import { generatePath } from 'react-router-dom';

import { PRODUCT_BASE_PATHS } from '@cast/console-constants';
import { getClusterIdFromLink } from 'features/cluster/routingUtils';

const BASE_URL = `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/settings`;
const AUTOSCALER_SETTING_BASE_URL = `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/autoscaler/settings`;

type Page = 'root' | 'evictor' | 'pod-mutator';

export const makeNavigationLinkTo = (page?: Page, clusterId?: string) =>
  generatePath(`${BASE_URL}${page !== 'root' ? `/${page}` : ''}`, {
    clusterId: clusterId ?? getClusterIdFromLink(),
  });

export const makeNavigationLinkToAutoscalerSettings = (clusterId?: string) =>
  generatePath(AUTOSCALER_SETTING_BASE_URL, {
    clusterId: clusterId ?? getClusterIdFromLink(),
  });
